<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="option_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('medical_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('medical_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="subDetail" v-html="$t('medical_desc')"></div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('medical_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('medical_table_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('medical_table_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('medical_table_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('medical_table_tr2_td1') }}</td>
                <td>{{ $t('medical_table_tr2_td2') }}</td>
                <td>{{ $t('medical_table_tr2_td3') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('medical_table_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('medical_combi_title') }}</div>
          <ol>
            <li>{{ $t('medical_combi_desc1') }}</li>
            <li>{{ $t('medical_combi_desc2') }}</li>
            <li>{{ $t('medical_combi_desc3') }}</li>
            <li>{{ $t('medical_combi_desc4') }}</li>
            <li>{{ $t('medical_combi_desc5') }}</li>
            <li>{{ $t('medical_combi_desc6') }}</li>
          </ol>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('medical_reserve_title') }}</div>
          <ol>
            <li>{{ $injectEmails($t('medical_reserve_desc1')) }}</li>
            <li>{{ $t('medical_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Medicalspa',
  data() {
    return {
      isLang: 0,
      option_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/option/medicalspa_01.jpg')},
        {image: require('@/assets/images/pleisure/option/medicalspa_01.jpg')},
        {image: require('@/assets/images/pleisure/option/medicalspa_01.jpg')},
        {image: require('@/assets/images/pleisure/option/medicalspa_01.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "medical_title": "메디컬 스파",
    "medical_subtitle": "메디컬과 스파가 융합된 바디&페이셜 트리트먼트 프로그램",
    "prev_button": "이전",
    "medical_desc": "다양한 최신 장비를 이용하여 피부와 근육, 면역력 등에 활력을 주는 안티에이징, 수기요법, 순환장애, 디톡스 요법 등 건강한 삶을 위한 다양한 체내 개선 프로그램을 만나실 수 있습니다.",
    "medical_program_title": "운영 프로그램",
    "medical_table_tr1_td1": "프로그램",
    "medical_table_tr1_td2": "옵션",
    "medical_table_tr1_td3": "요금(2인 기준)",
    "medical_table_tr2_td1": "바디 케어",
    "medical_table_tr2_td2": "60분",
    "medical_table_tr2_td3": "200,000 ~",
    "medical_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "medical_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "medical_combi_desc1": "프라이빗 럭셔리요트",
    "medical_combi_desc2": "챌린저 골프",
    "medical_combi_desc3": "노블승마",
    "medical_combi_desc4": "제주어부",
    "medical_combi_desc5": "해피투게더",
    "medical_combi_desc6": "제주 숲토리텔링 투어",
    "medical_reserve_title": "예약문의 및 상담",
    "medical_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "medical_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Option Program",
    "medical_title": "Medical Spa",
    "medical_subtitle": "Body & Facial treatment program combining medical treatment with spa.",
    "prev_button": "Previous",
    "medical_desc": "Using state-of-the-art equipment, Medical Spa provides various body improvement programs for healthy life, such as anti-aging, aero hydrotherapy, circulatory disorder, and detox therapy to revitalize your skin, muscles, and immune system.",
    "medical_program_title": "Program",
    "medical_table_tr1_td1": "Program",
    "medical_table_tr1_td2": "Option",
    "medical_table_tr1_td3": "Fare(2 people)",
    "medical_table_tr2_td1": "Whole Body Care",
    "medical_table_tr2_td2": "60 min.",
    "medical_table_tr2_td3": "KRW 200,000 ~",
    "medical_table_desc": "※ Special price for P-Leisure users",
    "medical_combi_title": "Combinable programs",
    "medical_combi_desc1": "private luxury yacht",
    "medical_combi_desc2": "challenger golf",
    "medical_combi_desc3": "noble riding",
    "medical_combi_desc4": "Jeju fisherman",
    "medical_combi_desc5": "Happytogether",
    "medical_combi_desc6": "Jeju forest-ory tour",
    "medical_reserve_title": "Reservation",
    "medical_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "medical_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {
    "breadcrumb": "옵션 프로그램",
    "medical_title": "메디컬 스파",
    "medical_subtitle": "메디컬과 스파가 융합된 바디&페이셜 트리트먼트 프로그램",
    "prev_button": "이전",
    "medical_desc": "다양한 최신 장비를 이용하여 피부와 근육, 면역력 등에 활력을 주는 안티에이징, 수기요법, 순환장애, 디톡스 요법 등 건강한 삶을 위한 다양한 체내 개선 프로그램을 만나실 수 있습니다.",
    "medical_program_title": "운영 프로그램",
    "medical_table_tr1_td1": "프로그램",
    "medical_table_tr1_td2": "옵션",
    "medical_table_tr1_td3": "요금(2인 기준)",
    "medical_table_tr2_td1": "바디 케어",
    "medical_table_tr2_td2": "60분",
    "medical_table_tr2_td3": "200,000 ~",
    "medical_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "medical_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "medical_combi_desc1": "프라이빗 럭셔리요트",
    "medical_combi_desc2": "챌린저 골프",
    "medical_combi_desc3": "노블승마",
    "medical_combi_desc4": "제주어부",
    "medical_combi_desc5": "해피투게더",
    "medical_combi_desc6": "제주 숲토리텔링 투어",
    "medical_reserve_title": "예약문의 및 상담",
    "medical_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "medical_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  }
}
</i18n>
